import { actionTypes as at } from './constants';
import { BasemapKey } from './model';

export const actionSetBasemap = (basemapKey: BasemapKey) => {
    return {
        type: at.SET_BASEMAP,
        payload: basemapKey,
    };
};